


























































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'

import UiSelectionDropdown from '@/components/semantic-ui/SelectionDropdown.vue'

import { PantryItem } from '@/datastore/models'

import grocery from '@/store/modules/grocery'

import PantryListItem from './PantryListItem.vue'

@Component({
	components: {
		PantryListItem,
		UiSelectionDropdown,
	},
})
export default class PantryUncategorizedList extends Vue {

	@Prop()
	readonly expanded?: boolean

	@Prop()
	readonly filter?: string

	addedPantryItem = ''

	isAddingPantryItem = false

	get items(): PantryItem[] {

		if (this.filter) {
			const filter = this.filter.toLocaleLowerCase()
			return grocery.uncategorizedPantryItems.filter(({ name }) => name.toLocaleLowerCase().includes(filter))
		}

		return grocery.uncategorizedPantryItems
	}

	get pantryItems(): PantryItem[] {

		return grocery.pantryItems
	}

	@Watch('addedPantryItem')
	async onWatchAddedPantryItem(): Promise<void> {

		this.isAddingPantryItem = true
		await grocery.addPantryItem(this.addedPantryItem)
		this.isAddingPantryItem = false
	}

}

